import JoinASpool from './JoinASpool/JoinASpool';
import { Tab, TabBody, TabContent, TabHeader, Tabs } from '../../components/Tabs';
import { config } from '../../config/config';
import CreateASpoolState from '../../context/createASpool/CreateASpoolState';
import CreateASpool from './CreateASpool';

const SpoolApp: React.FC = () => {
    return (
        <>
            <Tabs>
                <TabHeader>
                    <Tab to='/'>Join a Spool</Tab>
                    <Tab to='/create-a-spool'>Create a Spool</Tab>
                </TabHeader>
                <TabBody>
                    <TabContent to={['/', `/${config.urls.spoolPath}`]}>
                        <JoinASpool />
                    </TabContent>
                    <TabContent to={`/create-a-spool`}>
                        <CreateASpoolState>
                            <CreateASpool />
                        </CreateASpoolState>
                    </TabContent>
                </TabBody>
            </Tabs>
        </>
    );
};

export default SpoolApp;
